import { Button } from '@thanx/uikit/button'

import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('cms.settings.post_order_feedback')

type Props = {
  isSubmitting: boolean
  formDisabled: boolean
  handleSubmit: () => void
}

const Sidebar = ({ isSubmitting, formDisabled, handleSubmit }: Props) => {
  return (
    <Button
      className="mb-xxl px-s w-100"
      onClick={handleSubmit}
      isLoading={isSubmitting}
      disabled={formDisabled}
    >
      {t('publish')}
    </Button>
  )
}

export default Sidebar
